import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-full bg-background min-h-screen" }
const _hoisted_2 = { class: "flex flex-col container" }
const _hoisted_3 = { class: "w-full flex-row flex justify-between py-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M11 17l-5-5m0 0l5-5m-5 5h12"
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
  })
], -1)
const _hoisted_6 = {
  key: 0,
  class: "w-full"
}
const _hoisted_7 = {
  key: 2,
  class: "flex flex-row justify-center w-full py-3"
}
const _hoisted_8 = { class: "p-3" }
const _hoisted_9 = { action: "" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" > ")
const _hoisted_11 = { class: "flex flex-row justify-between items-center w-full p-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_TalentEvaluationCard = _resolveComponent("TalentEvaluationCard")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Button, {
            label: "Back",
            variant: "outlined",
            onOnClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router && _ctx.router?.push('/')))
          }, {
            startIcon: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            label: "Create a new template",
            variant: "contained",
            onOnClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router && _ctx.router?.push('/create-talent-evaluation')))
          }, {
            startIcon: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_Loading, {
                active: _ctx.isLoading,
                "onUpdate:active": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isLoading) = $event)),
                "can-cancel": false,
                loader: "spinner",
                color: "#8908F9",
                width: 128,
                height: 128,
                "is-full-page": true
              }, null, 8, ["active"])
            ]))
          : (_openBlock(), _createBlock(_component_TalentEvaluationCard, {
              key: 1,
              data: _ctx.evaluationsData,
              onArchiveTemplate: _ctx.archiveTemplate,
              onCopyTemplate: _ctx.copyTemplate
            }, null, 8, ["data", "onArchiveTemplate", "onCopyTemplate"])),
        (_ctx.evaluationsData?.length > 0 && !_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_Paginator, {
                modelValue: _ctx.page,
                page: _ctx.page,
                pages: _ctx.paginator.pagination.total_pages,
                "range-size": 1,
                "onUpdate:modelValue": _ctx.updateHandler,
                total: _ctx.paginator.pagination.total_count,
                from: _ctx.paginator.pagination.from,
                to: _ctx.paginator.pagination.to
              }, null, 8, ["modelValue", "page", "pages", "onUpdate:modelValue", "total", "from", "to"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_base_modal, { visible: _ctx.showModal }, {
      "alert-text": _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("form", _hoisted_9, [
            _createElementVNode("div", null, [
              _createVNode(_component_TextField, {
                modelValue: _ctx.templateName,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.templateName) = $event)),
                className: "pt-5 pb-2 pl-4 text-sm pr-2 block w-full px-0 mt-0 bg-transparent border-2 rounded-lg border-solid appearance-none focus:outline-none focus:ring-0 focus:border-gray-200 border-gray-200",
                label: "Template name",
                name: "template"
              }, null, 8, ["modelValue"])
            ])
          ])
        ])
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            class: "btn-outline-sm flex flex-row items-center disabled:opacity-50 justify-between px-4 py-2 text-primary truncate sm:text-base border-2 rounded-full transition duration-150 ease-in",
            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.confirmationModal.tell(false)), ["prevent"]))
          }, " Cancel "),
          _createElementVNode("button", {
            class: "btn-filled-sm flex flex-row items-center disabled:opacity-50 justify-between truncate sm:text-base bg-primary rounded-full transition duration-150 ease-in",
            onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.confirmationModal.tell(true)), ["prevent"]))
          }, " Copy template ")
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_10
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}